/* eslint-disable jsx-a11y/anchor-is-valid */

import { Modal } from "./Modal";
import { Routes } from "./Routes";
import { Navigation } from "./Navigation";
import { apiGet, BASE_URL } from "../store/api";
import { RootState } from "../store/rootReducer";
import { useDispatch, useSelector } from "react-redux";
import { updateMessage } from "../reducers/authorization/authorization.actions";

export const AppMain = () => {
  const dispatch = useDispatch();
  const token = useSelector((state: RootState) => state.authorization.token);

  const logout = () => {
    apiGet(`${BASE_URL}account/logout`, token).finally(() => {
      document.cookie.split(";").forEach((c) => {
        document.cookie = c
          .replace(/^ +/, "")
          .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
      });
      dispatch(updateMessage('logout_ok'));
    });
  }
  
  return (
    <div className="hold-transition skin-blue sidebar-mini">
      <div className="wrapper">
        <header className="main-header">
          <a href="#" className="logo">
            <span className="logo-mini">
              <b>UMN</b>
            </span>
            <span className="logo-lg">
              <b>Kerma</b>UMN
            </span>
          </a>
          <nav className="navbar navbar-static-top">
            <a href="#" className="sidebar-toggle" data-toggle="push-menu" role="button">
              <span className="sr-only">Toggle navigation</span>
            </a>
            <div className="navbar-custom-menu">
              <ul className="nav navbar-nav">
                <li>
                  <button className="btn-logout" onClick={() => logout()}>
                    <i className="fa fa-envelope-o"></i>
                    <span>KELUAR</span>
                  </button>
                </li>
              </ul>
            </div>
          </nav>
        </header>

        <Navigation />

        <div className="content-wrapper">
          <Routes />
          <Modal />
        </div>

        <footer className="main-footer">
          <div className="pull-right hidden-xs">
            <b>Version</b> 1.0.0alpha
          </div>
          <strong>&copy; 2021 Universitas Multimedia Nusantara, Jl. Scientia Boulevard, Gading Serpong, Tangerang, www.umn.ac.id</strong>.
        </footer>
      </div>
    </div>
  );
}